<main class="main">
  <section class="wrap-title">
    <div class="layout">
      <h1 class="title-page">Gestão de Entrada de Seminovos</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>
              É possível aumentar a rentabilidade da sua concessionária através da otimização da operação e
              administração eficiente da gestão do veículo. A avaliação pode ser feita da entrada ao destino final, seja
              Showroom ou Repasse. Esqueça os carros que “não fazem parte do perfil” da sua empresa: com a Gestão de
              Entrada de Seminovos você decide o perfil do carro através de uma precificação mais assertiva e benéfica
              para a empresa e o cliente final.
            </p>
            <p>
              Uma solução exclusiva Union que agrega qualidade e garantia aos veículos e a sua operação através de
              aperfeiçoamentos com as áreas que colaboram para a comercialização, como Marketing, Vendedores, Callcenter
              e até a Recepção da sua empresa. Com estas ações você garante a redução de riscos, proporciona aumento ao
              faturamento, ao giro e às margens. Pense grande ao buscar os melhores serviços veiculares para a sua
              concessionária.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="wrap-trends">
    <div class="layout">
      <h2 class="subtitle">Tendência de estrutura concessionária</h2>
      <div class="fig">
        <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/fluxograma-gestao.png"
          alt="Fluxograma Gestão">
      </div>
    </div>
  </section>

  <section class="wrap-planning">
    <div class="layout">
      <h2 class="subtitle">Planejamento Union</h2>
      <div class="fig">
        <img src="" alt="">
      </div>
      <div class="list-topics">
        <div class="text">
          <p>Marketing</p>
        </div>
        <div class="text">
          <p>Recepção</p>
        </div>
        <div class="text">
          <p>Call Center</p>
        </div>
        <div class="text">
          <p>Pátio de entrada</p>
        </div>
      </div>
    </div>
  </section>

  <section class="wrap-cases">
    <div class="layout">
      <h2 class="subtitle">Cases</h2>
      <div class="list-topics">
        <div class="icon">
          <span>DF | GO</span>
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/grupo-saga.png" alt="Grupo Saga" loading="lazy">
        </div>
        <div class="icon">
          <span>ES</span>
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/kuruma.png" alt="Kuruma" loading="lazy">
        </div>
        <div class="icon">
          <span>MT</span>
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/kyoto.png" alt="Kyoto" loading="lazy">
        </div>
        <div class="icon">
          <span>SP</span>
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/primavia.png" alt="Primavia" loading="lazy">
        </div>
        <div class="icon">
          <span>GO</span>
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/jorlan.png" alt="Jorlan" loading="lazy">
        </div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>
